import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck, AlertTriangle, Info, ShieldAlert } from "lucide-react";
import { toast } from "sonner";
import { Skeleton } from "@/components/ui/skeleton";

const ICONS = {
  info: { icon: Info, tone: "text-blue-600 bg-blue-500/10" },
  warning: { icon: AlertTriangle, tone: "text-amber-600 bg-amber-500/10" },
  danger: { icon: ShieldAlert, tone: "text-rose-600 bg-rose-500/10" },
};

export default function Notifications() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/notifications").then((r) => setRows(r.data)).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); toast.success("Semua ditandai dibaca"); load(); };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Pemberitahuan</p>
          <h1 className="text-2xl lg:text-3xl font-bold tracking-tight">Notifikasi</h1>
        </div>
        <Button data-testid="btn-read-all" variant="outline" onClick={markAll} className="gap-2">
          <CheckCheck className="h-4 w-4" /> Tandai semua dibaca
        </Button>
      </div>

      {loading ? <Skeleton className="h-40 w-full" /> : rows.length === 0 ? (
        <Card className="p-10 text-center">
          <Bell className="h-8 w-8 mx-auto text-muted-foreground/50" />
          <p className="mt-3 text-sm text-muted-foreground">Belum ada notifikasi</p>
        </Card>
      ) : (
        <Card>
          <div className="divide-y">
            {rows.map((n) => {
              const meta = ICONS[n.level] || ICONS.info;
              return (
                <div key={n.id} data-testid={`notif-row-${n.id}`} className={`flex gap-3 px-4 py-3 ${!n.read ? "bg-primary/5" : ""}`}>
                  <div className={`h-9 w-9 rounded-lg grid place-items-center shrink-0 ${meta.tone}`}>
                    <meta.icon className="h-4 w-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold">{n.title}</p>
                    <p className="text-xs text-muted-foreground">{n.message}</p>
                    <p className="text-xs text-muted-foreground/70 mt-1">{formatDateTime(n.created_at)}</p>
                  </div>
                  {!n.read && (
                    <Button data-testid={`btn-read-${n.id}`} size="sm" variant="ghost" onClick={() => markRead(n.id)}>
                      Tandai
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
